<div class="inputSelect">
  <input class="inputSelect-field" type="text" [(ngModel)]="input" (keyup)="filter($event)" autocomplete="dont_do_anything" spellcheck="false" placeholder="{{ 'Standard.Search' | translate }} {{ 'Standard.DeliveryAddress' | translate | lowercase }}"/>
  <button class="inputSelect-clear bg-secondary text-white" (click)="clear()" *ngIf="input != ''">X</button>
  <div class="inputSelect-list bg-light" *ngIf="!!show && show.length != 0">
    <div *ngFor="let x of show; let i = index">
      <div class="inputSelect-listItem" (mousedown)="change(i)" id="{{x.deliveryId}}" [ngClass]="index == i ? 'highlit':''">
        <div>{{ x.name }}</div>
        <div>{{ x.street }}</div>
        <div>{{ x.zipCode }} {{ x.city }}</div>
        <div>{{ x.email }}</div>
        <div>{{ x.phone }}</div>
      </div>
    </div>
  </div>
</div>
